<template>
  <div>
    <div class="ui secondary pointing top attached tabular menu three item">
      <a class="item active" v-on:click="getRPDs(currentPageRPD)" data-tab="rpd_soft">Рабочие программы дисциплин</a>
      <a class="item" v-on:click="getRPPs(currentPageRPP)" data-tab="rpp_soft">Рабочие программы практик</a>
      <a class="item" v-on:click="getRPGs(currentPageRPG)" data-tab="rpg_soft">Рабочие программы ГИА</a>
    </div>
    <div class="ui bottom attached tab segment active" data-tab="rpd_soft">
      <div class="ui styled fluid accordion" >
        <div v-for="prog in rpd">
          <div class="title">
            <tr>
              <td width="2%">
                <i class="dropdown icon"></i>
              </td>
              <td width="35%">
                {{ prog.main_info.discipline }}
              </td>
              <td width="35%">
                {{ prog.main_info.speciality }}
              </td>
              <td width="20%">
                {{ prog.main_info.creator.fio }}
              </td>
              <td width="8%">
                {{ prog.main_info.year }}
              </td>
            </tr>
          </div>
          <div class="content">
            <tr>
              <td width="15%"><h4>Отправленно на согласование</h4></td>
              <td width="10%">{{new Date(prog.updated_at).toISOString().slice(0, 10)}}</td>
              <td width="25%">
                <h4>
                  Отправлено {{prog.software_agreed_times}} раз
                </h4>
              </td>
            </tr>
            <div class="ui fitted divider"></div>
            <table class="ui basic celled table">
              <thead>
              <tr class="active">
                <th width="20%"><div class="headTable">Наименование</div></th>
                <th width="40%"><div class="headTable">Описание</div></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for = "soft in prog.software">
                <td>
                  {{soft.info.name}}
                </td>
                <td>
                  {{ soft.info.license }}
                </td>
              </tr>
              <tr v-for = "res in prog.resources">
                <td>{{res.name}}</td>
                <td>{{res.desc}}</td>
              </tr>
              </tbody>
            </table>
            <div class="ui fitted divider"></div>
            <div>
              <button class="ui button negative" v-on:click="denyRPD(prog.id, rpd.indexOf(prog), prog.software_agreed_times)">
                Отклонить
              </button>
              <button class="ui right floated button positive" v-on:click="agreedRPD(prog.id, rpd.indexOf(prog))">
                Согласовать
              </button>
            </div>
          </div>
        </div>
      </div>
      <div id="app_soft">
        <tiny-pagination
            :showLimit = false
            :total="currentTotal"
            @tiny:change-page="changePageRPD" />
      </div>
    </div>
    <div class="ui bottom attached tab segment" data-tab="rpp_soft">
      <div class="ui styled fluid accordion" >
        <div v-for="prog in rpp">
          <div class="title">
            <tr>
              <td width="2%">
                <i class="dropdown icon"></i>
              </td>
              <td width="35%">
                {{ prog.main_info.discipline }}
              </td>
              <td width="35%">
                {{ prog.main_info.speciality }}
              </td>
              <td width="20%">
                {{ prog.main_info.creator.fio }}
              </td>
              <td width="8%">
                {{ prog.main_info.year }}
              </td>
            </tr>
          </div>
          <div class="content">
            <tr>
              <td width="15%"><h4>Отправленно на согласование</h4></td>
              <td width="10%">{{new Date(prog.updated_at).toISOString().slice(0, 10)}}</td>
              <td width="25%">
                <h4>
                  Отправлено {{prog.software_agreed_times}} раз
                </h4>
              </td>
            </tr>
            <div class="ui fitted divider"></div>
            <table class="ui basic celled table">
              <thead>
              <tr class="active">
                <th width="20%"><div class="headTable">Наименование</div></th>
                <th width="40%"><div class="headTable">Описание</div></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for = "soft in prog.software">
                <td>
                  {{soft.info.name}}
                </td>
                <td>
                  {{ soft.info.license }}
                </td>
              </tr>
              <tr v-for = "res in prog.resources">
                <td>{{res.name}}</td>
                <td>{{res.desc}}</td>
              </tr>
              </tbody>
            </table>
            <div class="ui fitted divider"></div>
            <div>
              <button class="ui button negative" v-on:click="denyRPP(prog.id, rpp.indexOf(prog), prog.software_agreed_times)">
                Отклонить
              </button>
              <button class="ui right floated button positive" v-on:click="agreedRPP(prog.id, rpp.indexOf(prog))">
                Согласовать
              </button>
            </div>
          </div>
        </div>
      </div>
      <div id="app_soft_rpp">
        <tiny-pagination
            :showLimit = false
            :total="currentTotal"
            @tiny:change-page="changePageRPP" />
      </div>
    </div>
    <div class="ui bottom attached tab segment" data-tab="rpg_soft">
      <div class="ui styled fluid accordion" >
        <div v-for="prog in rpg">
          <div class="title">
            <tr>
              <td width="2%">
                <i class="dropdown icon"></i>
              </td>
              <td width="35%">
                {{ prog.name }}
              </td>
              <td width="35%">
                {{ prog.main_info.speciality }}
              </td>
              <td width="20%">
                {{ prog.main_info.creator.fio }}
              </td>
              <td width="8%">
                {{ prog.main_info.year }}
              </td>
            </tr>
          </div>
          <div class="content">
            <tr>
              <td width="15%"><h4>Отправленно на согласование</h4></td>
              <td width="10%">{{new Date(prog.updated_at).toISOString().slice(0, 10)}}</td>
              <td width="25%">
                <h4>
                  Отправлено {{prog.software_agreed_times}} раз
                </h4>
              </td>
            </tr>
            <div class="ui fitted divider"></div>
            <table class="ui basic celled table">
              <thead>
              <tr class="active">
                <th width="20%"><div class="headTable">Наименование</div></th>
                <th width="40%"><div class="headTable">Описание</div></th>
              </tr>
              </thead>
              <tbody>
              <tr v-for = "soft in prog.software">
                <td>
                  {{soft.info.name}}
                </td>
                <td>
                  {{ soft.info.license }}
                </td>
              </tr>
              <tr v-for = "res in prog.resources">
                <td>{{res.name}}</td>
                <td>{{res.desc}}</td>
              </tr>
              </tbody>
            </table>
            <div class="ui fitted divider"></div>
            <div>
              <button class="ui button negative" v-on:click="denyRPG(prog.id, rpg.indexOf(prog), prog.software_agreed_times)">
                Отклонить
              </button>
              <button class="ui right floated button positive" v-on:click="agreedRPG(prog.id, rpg.indexOf(prog))">
                Согласовать
              </button>
            </div>
          </div>
        </div>
      </div>
      <div id="app_soft_rpg">
        <tiny-pagination
            :showLimit = false
            :total="currentTotal"
            @tiny:change-page="changePageRPG" />
      </div>
    </div>
    <div class="ui modal" id="deny_soft_modal">
      <div class="ui header">Отклонить?</div>
      <div class="content">
        <div class="ui form">
          <div class="field">
            <label>Оставить отзыв (опционально)</label>
            <textarea v-model="deny_text"></textarea>
          </div>
        </div>
      </div>
      <div class="actions">
        <div class="ui gray deny button">
          Закрыть
        </div>
        <div class="ui positive inverted right labeled icon button">
          Подтвердить
          <i class="checkmark icon"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { TinyPagination } from 'vue-tiny-pagination';

export default {
  name: "software_agreed_rpd",
  components: {
    TinyPagination,
  },
  data: () => ({
    rpd: [],
    rpp: [],
    rpg: [],
    deny_text: "",
    currentTotal: 100,
    currentPageRPD: 1,
    currentPageRPP: 1,
    currentPageRPG: 1,
  }),
  methods: {
    getRPDs(currentPageRPD) {
      axios({
        method: 'get',
        url: `/programms/software_agreed/${currentPageRPD}`
      }).then((response) => {
        this.rpd = response.data.rpd
        this.rpd.sort(function (a, b) {
          return a.id - b.id;
        });
      }).catch((error) => {
        return error;
      });
    },
    denyRPD(id, index, times){
      this.deny_text = "";
      $('#deny_soft_modal').modal({
        closable: false,
        autofocus: false,
        onDeny: () => {
        },
        onApprove: () => {
          const token = document.querySelector('[name=csrf-token]').content;
          axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
          axios({
            method: 'put',
            url: '/programms/rpd/' + id,
            data: {
              data: {
                software_agreed: false,
                software_comment: this.deny_text,
                software_agreed_times: times + 1,
                considered: false,
              }
            }
          }).then((response) => {
            this.rpd.splice(index, 1)
            if (!this.rpd.length){
              this.getRPDs(this.currentPageRPD)
            }
          }).catch((error) => {
            return error;
          });
        }
      }).modal('show');
    },
    agreedRPD(id, index){
      const token = document.querySelector('[name=csrf-token]').content;
      axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
      axios({
        method: 'put',
        url: '/programms/rpd/' + id,
        data: {
          data: {
            software_agreed: true,
          }
        }
      }).then((response) => {
        this.rpd.splice(index, 1)
        if (!this.rpd.length){
          this.getRPDs(this.currentPageRPD)
        }
      }).catch((error) => {
        return error;
      });
    },
    changePageRPD (pagination) {
      this.currentPageRPD = pagination.page;
      this.getRPDs(this.currentPageRPD)
    },
    getRPPs(currentPageRPP) {
      axios({
        method: 'get',
        url: `/programms/software_agreed_rpp/${currentPageRPP}`
      }).then((response) => {
        this.rpp = response.data.rpp
        this.rpp.sort(function (a, b) {
          return a.id - b.id;
        });
      }).catch((error) => {
        return error;
      });
    },
    denyRPP(id, index, times){
      this.deny_text = "";
      $('#deny_soft_modal').modal({
        closable: false,
        autofocus: false,
        onDeny: () => {
        },
        onApprove: () => {
          const token = document.querySelector('[name=csrf-token]').content;
          axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
          axios({
            method: 'put',
            url: '/programms/rpp/' + id,
            data: {
              data: {
                software_agreed: false,
                software_comment: this.deny_text,
                software_agreed_times: times + 1,
                considered: false,
              }
            }
          }).then((response) => {
            this.rpp.splice(index, 1)
            if (!this.rpp.length){
              this.getRPPs(this.currentPageRPP)
            }
          }).catch((error) => {
            return error;
          });
        }
      }).modal('show');
    },
    agreedRPP(id, index){
      const token = document.querySelector('[name=csrf-token]').content;
      axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
      axios({
        method: 'put',
        url: '/programms/rpp/' + id,
        data: {
          data: {
            software_agreed: true,
          }
        }
      }).then((response) => {
        this.rpp.splice(index, 1)
        if (!this.rpp.length){
          this.getRPPs(this.currentPageRPP)
        }
      }).catch((error) => {
        return error;
      });
    },
    changePageRPP (pagination) {
      this.currentPageRPP = pagination.page;
      this.getRPPs(this.currentPageRPP)
    },
    getRPGs(currentPageRPG) {
      axios({
        method: 'get',
        url: `/programms/software_agreed_rpg/${currentPageRPG}`
      }).then((response) => {
        this.rpg = response.data.rpg
        this.rpg.sort(function (a, b) {
          return a.id - b.id;
        });
      }).catch((error) => {
        return error;
      });
    },
    denyRPG(id, index, times){
      this.deny_text = "";
      $('#deny_soft_modal').modal({
        closable: false,
        autofocus: false,
        onDeny: () => {
        },
        onApprove: () => {
          const token = document.querySelector('[name=csrf-token]').content;
          axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
          axios({
            method: 'put',
            url: '/programms/rpg/' + id,
            data: {
              data: {
                software_agreed: false,
                software_comment: this.deny_text,
                software_agreed_times: times + 1,
                considered: false,
              }
            }
          }).then((response) => {
            this.rpg.splice(index, 1)
            if (!this.rpg.length){
              this.getRPGs(this.currentPageRPG)
            }
          }).catch((error) => {
            return error;
          });
        }
      }).modal('show');
    },
    agreedRPG(id, index){
      const token = document.querySelector('[name=csrf-token]').content;
      axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
      axios({
        method: 'put',
        url: '/programms/rpg/' + id,
        data: {
          data: {
            software_agreed: true,
          }
        }
      }).then((response) => {
        this.rpg.splice(index, 1)
        if (!this.rpg.length){
          this.getRPGs(this.currentPageRPG)
        }
      }).catch((error) => {
        return error;
      });
    },
    changePageRPG (pagination) {
      this.currentPageRPG = pagination.page;
      this.getRPGs(this.currentPageRPG)
    },
  },

  mounted() {
    this.getRPDs(this.currentPageRPD)
  }
}
</script>

<style scoped>

</style>